import { render, staticRenderFns } from "./workOrrest.vue?vue&type=template&id=434d52ae&scoped=true&"
import script from "./workOrrest.vue?vue&type=script&lang=js&"
export * from "./workOrrest.vue?vue&type=script&lang=js&"
import style0 from "./workOrrest.vue?vue&type=style&index=0&id=434d52ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434d52ae",
  null
  
)

export default component.exports